export const contblockNotFound = 'ERROR: Could not fetch the document for';

// get a content block from Hippo
export async function fetchContentBlock(identifier: string) {
    const contentBlockApiUrl = window.topContext.config.getEndpointConfig().htmlContent;
    let contentBlocksUrl = '';
    if (identifier.startsWith('common')) {
        contentBlocksUrl = `/?&documentPath=shared/content-blocks/privat/selvbetjening/kobsflow/online-koeb/${identifier}&template=nowrapper`;
    } else {
        contentBlocksUrl = `/?documentPath=shared/content-blocks/erhverv/kob-tilbud/online-koeb/erhvervsforsikring/${identifier}&template=nowrapper`;
    }

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'text/html',
        },
    };

    return fetch(`${contentBlockApiUrl}${contentBlocksUrl}`, options)
        .then(async (response) => {
            if (response.ok) {
                return response.text().then((text) => {
                    const stripped = text.trim();
                    if (stripped.startsWith(contblockNotFound)) {
                        throw new Error(`could not find ${identifier} on ${contentBlockApiUrl}${contentBlocksUrl}`);
                    } else {
                        return { name: identifier, data: text };
                    }
                });
            } else {
                return Promise.reject('failed to fetch content block, not ok');
            }
        })
        .catch((err) => {
            return Promise.reject(`failed to fetch content block, other error ${err}`);
        });
}

// get a resource bundle from Hippo
export async function fetchResourceBundle(identifier: string) {
    const resourceBundleApiUrl = window.topContext.config.getEndpointConfig().resourceBundle;
    return fetch(`${resourceBundleApiUrl}/${identifier}`)
        .then(async (response) => {
            if (response.ok) {
                const json = await response.json();
                return json;
            } else {
                return Promise.reject('failed to fetch resource bundle, not ok');
            }
        })
        .catch((err) => {
            return Promise.reject(`failed to fetch resource bundle, other error ${err}`);
        });
}

// wrap a Promise(return from fetch) so that it can be used with Suspense
export const wrapPromise = (promise: Promise<any>) => {
    let status = 'pending';
    let result: any;
    let suspend = promise.then(
        (res) => {
            status = 'success';
            result = res;
        },
        (err) => {
            status = 'error';
            result = err;
        },
    );
    return {
        read() {
            if (status === 'pending') {
                throw suspend;
            } else if (status === 'error') {
                throw result;
            } else if (status === 'success') {
                return result;
            }
        },
    };
};

// get resource bundle from Hippo, in a form usable by Suspense
export const getResourceBundle = (identifier: string) => {
    return wrapPromise(fetchResourceBundle(identifier));
};

// get content block from Hippo, in a form usable by Suspense
export const getContentBlock = (identifier: string) => {
    return wrapPromise(fetchContentBlock(identifier));
};
